"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const EducationCodes_1 = tslib_1.__importDefault(require("./EducationCodes"));
class RoleHelper {
    static forName(roleNameStr) {
        let role = this.roles[roleNameStr];
        if (!role && roleNameStr.startsWith("urn:dk:healthcare:national-federation-role:")) {
            const [roleName, schemaName] = roleNameStr.split("/");
            role = {
                id: -1,
                isAssistantRole: false,
                schemaName: schemaName,
                name: roleName,
                equals: (rl) => rl.schemaName === roleNameStr
            };
        }
        if (!role) {
            throw new Error(`Unknown role name "${roleNameStr}"`);
        }
        return role;
    }
    static forSchemaName(schemaName) {
        const role = Object.values(this.roles).find(currentRole => currentRole.schemaName === schemaName);
        if (!role) {
            throw new Error(`Unknown role schemaName "${schemaName}"`);
        }
        return role;
    }
    static allRoles() {
        return Object.values(this.roles);
    }
    static roleForEducationCode(educationCode) {
        return Object.values(this.roles).find(role => role.educationCode === educationCode) || null;
    }
    static isTrustBasedRole(role) {
        return role === this.Pharmacist
            || role === this.Pharmaconomist
            || role === this.SosuHelp
            || role === this.HealthVisitor;
    }
    static createRole(id, isAssistantRole, schemaName, name, educationCode) {
        // Skip dummy
        const role = {
            educationCode,
            equals: (queriedRole) => queriedRole.id === id,
            id,
            isAssistantRole,
            name,
            schemaName
        };
        // private static is set after public static, so we need to define it like this
        if (!this.roles) {
            this.roles = {};
        }
        if (id > 0) {
            this.roles[name] = role;
        }
        return role;
    }
}
// Roles / data properties
RoleHelper.Dummy = RoleHelper.createRole(-1, false, "dummy", "dummy");
RoleHelper.Doctor = RoleHelper.createRole(1, false, "Læge", "doctor", EducationCodes_1.default.DOCTOR);
RoleHelper.Dentist = RoleHelper.createRole(2, false, "Tandlæge", "dentist", EducationCodes_1.default.DENTIST);
RoleHelper.Midwife = RoleHelper.createRole(3, false, "Jordemoder", "midwife", EducationCodes_1.default.MIDWIFE);
/* Note: "Sygeplejer" is also accepted as schema name for nurse, for backwards compatibility
 * This is implemented in SecurityContext/AuditLogVO.setRequestedRole which converts the role name. */
RoleHelper.Nurse = RoleHelper.createRole(4, false, "Sygeplejerske", "nurse", EducationCodes_1.default.NURSE);
RoleHelper.SosuAssist = RoleHelper.createRole(5, false, "Social- og sundhedsassistent", "sosuassist", EducationCodes_1.default.SOSU_ASSIST);
RoleHelper.SosuHelp = RoleHelper.createRole(6, false, "Social- og sundhedshjælper", "sosuhelp", EducationCodes_1.default.SOSU_HELPER);
RoleHelper.HealthVisitor = RoleHelper.createRole(7, false, "Sundhedsplejerske", "healthvisitor", EducationCodes_1.default.HEALTH_VISITOR);
RoleHelper.Pharmacist = RoleHelper.createRole(8, false, "Farmaceut", "pharmacist", EducationCodes_1.default.PHARMACIST);
RoleHelper.Pharmaconomist = RoleHelper.createRole(9, false, "Farmakonom", "pharmaconomist", EducationCodes_1.default.PHARMACONOMIST);
RoleHelper.Chemist = RoleHelper.createRole(10, false, "Apoteker", "chemist");
RoleHelper.MunicipalEmployee = RoleHelper.createRole(11, false, "Kommunal ansat til medicinhåndtering", "municipalemployee");
RoleHelper.PharmacyEmployee = RoleHelper.createRole(12, false, "Apoteksansat", "pharmacy employee");
RoleHelper.AssistantForDoctor = RoleHelper.createRole(101, true, "Assistent for Læge", "assistant for doctor", EducationCodes_1.default.DOCTOR);
RoleHelper.AssistantForDentist = RoleHelper.createRole(102, true, "Assistent for Tandlæge", "assistant for dentist", EducationCodes_1.default.DENTIST);
RoleHelper.AssistantForMidwife = RoleHelper.createRole(103, true, "Assistent for Jordemoder", "assistant for midwife", EducationCodes_1.default.MIDWIFE);
RoleHelper.AssistantForNurse = RoleHelper.createRole(104, true, "Assistent for Sygeplejerske", "assistant for nurse", EducationCodes_1.default.NURSE);
RoleHelper.AssistantForSosuAssist = RoleHelper.createRole(105, true, "Assistent for Social- og sundhedsassistent", "assistant for sosuassist", EducationCodes_1.default.SOSU_ASSIST);
RoleHelper.AssistantForPharmacist = RoleHelper.createRole(106, true, "Assistent for Farmaceut", "assistant for" +
    " pharmacist", EducationCodes_1.default.PHARMACIST);
RoleHelper.AssistantForPharmaconomist = RoleHelper.createRole(107, true, "Assistent for Farmakonom", "assistant for pharmaconomist", EducationCodes_1.default.PHARMACONOMIST);
RoleHelper.AssistantForSosuHelp = RoleHelper.createRole(108, true, "Assistent for Social- og sundhedshjælper", "assistant for sosuhelp", EducationCodes_1.default.SOSU_HELPER);
RoleHelper.AssistantForHealthVisitor = RoleHelper.createRole(109, true, "Assistent for Sundhedsplejerske", "assistant for healthvisitor", EducationCodes_1.default.SOSU_HELPER);
RoleHelper.AssistantForChemist = RoleHelper.createRole(110, true, "Assistent for Apoteker", "assistant for chemist");
RoleHelper.PharmacistWithPrescriptionRights = RoleHelper.createRole(13, false, "Behandlerfarmaceut", "pharmacist with" +
    " prescription rights", EducationCodes_1.default.PHARMACIST_WITH_PRESCRIPTION_RIGHTS);
RoleHelper.Citizen = RoleHelper.createRole(50, false, "Borger", "citizen");
RoleHelper.ParentAuthority = RoleHelper.createRole(51, false, "Forældermyndighed", "parentauthority");
RoleHelper.Guardian = RoleHelper.createRole(52, false, "Værge", "guardian");
RoleHelper.System = RoleHelper.createRole(53, false, "System", "system");
RoleHelper.Supporter = RoleHelper.createRole(54, false, "Supporter", "supporter");
RoleHelper.ECPRCoordinator = RoleHelper.createRole(59, false, "eCPR koordinator", "eCPR coordinator");
RoleHelper.VaccinePassportSupporter = RoleHelper.createRole(60, false, "Vaccinepas Supporter", "vaccine passport supporter");
RoleHelper.VaccinePassportSupporterWithAddress = RoleHelper.createRole(61, false, "Vaccinepas Supporter med Adresse", "vaccine passport supporter with address");
RoleHelper.Anonymous = RoleHelper.createRole(150, false, "Anonym", "anonymous");
RoleHelper.WebAdmin = RoleHelper.createRole(999, false, "Web administrator", "webadmin");
exports.default = RoleHelper;
//# sourceMappingURL=RoleHelper.js.map